import React, { Component } from 'react';
import AdmissionApi from '../../Services/AdmissionApi';

import './style.css';

import Header from '../Header';
import Footer from '../Footer';
import CallToAction from '../CallToAction/CallToAction';

class Contactus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      errors: {},
      check: false
    }
    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    let data = localStorage.getItem('type');
    this.setState({ type: data });
  }

  handleChange = (e) => {
    const { name, value } = e.target
    this.setState({ [name]: value })

    this.resetErrorMsg(name)
  }

  resetErrorMsg = (errorId) => {
    this.setState((preState) => ({
      errors: { ...preState.errors, [errorId]: "" },
    }))
  }

  handleValidation = () => {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;

    //Email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }

    if (fields['email'] && !fields["email"].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      formIsValid = false;
      errors["email"] = "Email is not valid";
    }

    //name
    if (!fields["name"]) {
      formIsValid = false;
      errors["name"] = "Cannot be empty";
    }

    if (fields["name"] && /[^A-Za-z \.]/.test(fields['name'])) {
      formIsValid = false;
      errors["name"] = "Special characters and numbers are not allowed";
    }


    //Subject
    if (!fields["subject"]) {
      formIsValid = false;
      errors["subject"] = "Cannot be empty";
    }

    //Phone
    if (!fields['phone']) {
      formIsValid = false;
      errors['phone'] = "Cannot be empty";
    }

    //Message
    if (!fields['message']) {
      formIsValid = false;
      errors['message'] = "Cannot be empty";
    }

    errors['responseError'] = "";


    this.setState({ errors: errors });
    return formIsValid;
  }

  updateState = (newResponse) => {
    let errors = {};
    errors['request'] = "Your request sent successfully.";
    this.setState({ errors: errors, name: "", email: "", phone: "", subject: "", message: "" });
    setTimeout(() => this.setState({ errors: '' }), 3000)
  }

  handleContactClick = () => {
    if (!this.handleValidation()) return
    this.setState({ check: true })

    let mailobj = {
      action: 'contact_form',
      appid: "",
      clientid: "",
      address: { to: "info@admizzionzcampuz.com", name: this.state.name.trim() },
      mail_data: {
        name: this.state.name.trim(),
        email: this.state.email,
        subject: this.state.subject,
        phone: this.state.phone,
        message: this.state.message
      }
    };
    this.admissionsService.sendMail(this.updateState, mailobj, 'settings/v1/mail/send');
  }



  render() {
    const {
      name,
      email,
      subject,
      phone,
      message,
    } = this.state

    return (
      <div className='Contactus'>
        <Header />
        <section className='admn-contact'>
          <div className='container'>
            <div className='row'>
              <div className='col-sm-12 col-lg-4 mb-4 mb-lg-0'>
                <div className="admn-contact__content">
                  <h1>Contact Us</h1>
                  <div className='admn-contact__address'>
                    <div className="admn-contact__heading">
                      <i className="contact-icon icon-real-estate-027 u-line-icon-pro"></i>
                      <span className='ml-2'>Office</span>
                    </div>
                    <p>S1, S2, S3, 93 Adarshini Plaza, Adchini Village, Sri Aurobindo Marg, New Delhi - 110017</p>
                  </div>
                  <div className='admn-contact__address'>
                    <div className="admn-contact__heading">
                      <i className="contact-icon icon-electronics-005 u-line-icon-pro"></i>
                      <span className='ml-2'>Phone</span>
                      <p>+91 7827048199</p>
                    </div>
                  </div>
                  <div className='admn-contact__address'>
                    <div className="admn-contact__heading">
                      <i className="contact-icon icon-communication-062 u-line-icon-pro"></i>
                      <span className='ml-2'>Chat to us</span>
                    </div>
                    <p>info@admizzionzcampuz.com</p>
                  </div>
                </div>
              </div>
              <div className='col-sm-12 col-lg-8 d-flex align-items-center'>
                <div className="row px-lg-5">
                  <div className="col-md-6 form-group g-mb-20">
                    <input className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="text" placeholder="Name" name="name" value={name} onChange={this.handleChange} />
                    <span style={{ color: "red", float: "right", fontWeight: "100" }}>{this.state.errors["name"]}</span>
                  </div>
                  <div className="col-md-6 form-group g-mb-20">
                    <input className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="email" placeholder="Email" name="email" value={email} onChange={this.handleChange} />
                    <span style={{ color: "red", float: "right", fontWeight: "100" }}>{this.state.errors["email"]}</span>
                  </div>
                  <div className="col-md-6 form-group g-mb-20">
                    <input className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="text" placeholder="Subject" name="subject" value={subject} onChange={this.handleChange} />
                    <span style={{ color: "red", float: "right", fontWeight: "100" }}>{this.state.errors["subject"]}</span>
                  </div>
                  <div className="col-md-6 form-group g-mb-20">
                    <input className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover rounded-3 g-py-13 g-px-15" type="tel" placeholder="Phone" name="phone" value={phone} onChange={this.handleChange} />
                    <span style={{ color: "red", float: "right", fontWeight: "100" }}>{this.state.errors["phone"]}</span>
                  </div>
                  <div className="col-md-12 form-group g-mb-20">
                    <textarea className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v3 g-brd-primary--hover g-resize-none rounded-3 g-py-13 g-px-15" rows="7" placeholder="Message" name="message" value={message} onChange={this.handleChange}></textarea>
                    <span style={{ color: "red", float: "right", fontWeight: "100" }}>{this.state.errors["message"]}</span>
                    <span style={{ color: "green", float: "right", fontWeight: "100" }}>{this.state.errors["request"]}</span>
                  </div>
                  <div className="col-md-12">
                    <div className="">
                      <button className="admn-cta-btn w-100 btn u-btn-primary g-font-weight-600 g-font-size-13 text-uppercase g-rounded-25 g-py-15 g-px-30" onClick={this.handleContactClick} role="button">Send Request</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CallToAction />

        <Footer />
      </div>
    );
  }
}

export default Contactus;



/** WEBPACK FOOTER **
 ** ./src/components/Contactus/index.js
 **/